export class SlugRegistry<T> {
  registry: Map<string, T> = new Map();
  slugs: string[] = [];

  constructor(readonly items: T[], readonly slugFn: (param: T) => string) {
    for (let i = 0; i < items.length; i++) {
      const slug = slugFn(items[i]);
      this.registry.set(slug, items[i]);
      this.slugs.push(slug);
    }
  }

  get(slug: string): T {
    return this.registry.get(slug)!;
  }

  get length(): number {
    return this.slugs.length;
  }
}
